import React from "react";
import arrow from "../../icons/Arrow.png"
import pic from "../../images/homebanner.png"

const HomeBeforeAfter = () => {
  return (
    <div className="bg-homebeforeafter pt-5 pb-5 mt-5">
      <div className="container">
      <div className="label-head  bg-white ">-- BEFORE & AFTER --</div>

        <div className="row">
          <div className="col-lg-8  px-4">
            <div >
              <h1 className="">
                See Our
                <span className="color-white">
                  Design
                  <br />
                  Transformation
                </span>
              </h1>
            </div>
          </div>
          <div className="col-lg-4  ">
          <button className="quote-btn">Get A Quote</button>
</div>
          <div className="col-lg-12">
            <div className="homebeforeafter-wrap">
              <div className="homebeforeafter-wrap-left">
                <img src={pic} alt="" className="image-first" />
                <img src={arrow} alt="" className="image-second" />
              </div>
              <div className="homebeforeafter-wrap-right">
                <img src={pic} alt="" className="image-first" />
                <img src={arrow} alt="" className="image-second" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeBeforeAfter;
